// src/utils/inAppBrowser.js
// 카카오톡/라인/인스타 등 인앱 브라우저(웹뷰) 감지 + 외부 브라우저 열기.
// 구글은 웹뷰에서의 OAuth 로그인을 정책적으로 차단(disallowed_useragent)하므로,
// 로그인/가입 화면에서 외부 브라우저로 유도해야 한다.

const UA = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

export function detectInAppBrowser() {
  const ua = UA;
  if (/KAKAOTALK/i.test(ua)) return 'kakaotalk';
  if (/\bLine\//i.test(ua)) return 'line';
  if (/Instagram/i.test(ua)) return 'instagram';
  if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook';
  if (/DaumApps/i.test(ua)) return 'daum';
  if (/NAVER\(inapp/i.test(ua)) return 'naver';
  return null;
}

// 가능한 경우 외부 브라우저로 현재 URL 을 다시 연다. 성공 시 true.
export function openInExternalBrowser() {
  const url = window.location.href;
  const provider = detectInAppBrowser();

  if (provider === 'kakaotalk') {
    window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(url)}`;
    return true;
  }
  if (provider === 'line') {
    const sep = url.includes('?') ? '&' : '?';
    window.location.href = `${url}${sep}openExternalBrowser=1`;
    return true;
  }
  // 기타 안드로이드 웹뷰 → 크롬 intent
  if (/Android/i.test(UA)) {
    const noScheme = url.replace(/^https?:\/\//, '');
    window.location.href = `intent://${noScheme}#Intent;scheme=https;package=com.android.chrome;end`;
    return true;
  }
  // iOS 기타 웹뷰는 자동 전환 불가 → 수동 안내(링크 복사)
  return false;
}
